export function parseLaunchMode(value: string | undefined) {
    return value === 'true';
}

export function isLaunchModeEnabled() {
    return parseLaunchMode(import.meta.env.VITE_LAUNCH_MODE);
}
